import React from "react";
import Cookies from "universal-cookie";

import AppleSignIn from "react-apple-signin-auth";
import { AuthenticationService } from "../../core/services/authentication.service";
import { HelperConfig, HelperWebView } from "../../core/services/helper/helper.service";
import { IconApple, IconGoogle } from "../../assets/svgs-index";
import ModalInformation from "../../components/Modals/ModalInformation";

class loginProvider extends React.Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.refModal = React.createRef();
    this.googleInitialized = false;
    this.state = {
      modalInfoIsOpen: false,
      modalInfoMessage: "",
      modalInfoSubMessage: "",
      modalInfoTitle: "",
      modalInfoConfirmText: "",
      modalInfoOnConfirm: undefined,
      modalShowClose: true,
      signUpWarningSent: false,
      iagree: props.iagree,
      login: props.login,
      loading: false,
    };
  }

  componentDidMount() {
    // Expose a funcion to the global context for Android and iOS apps to call in case of error.
    window.handleSignInFailure = (error) => {
      //TODO: Open model with message error. Authentication failed please try again l8r
    };
    // Expose a function to the global context (window) for Android and Apple to call
    if (this.props.provider === "google") {
      window.receiveGoogleToken = (token) => {
        const objProviderResponse = { credential: token };
        this.handleGoogleAuthCallbackResponse(objProviderResponse);
      };
    }
    // Expose a function to the global context (window) for Apple to call
    if (this.props.provider === "apple") {
      window.receiveAppleToken = (token, client_id) => {
        const objProviderResponse = { authorization: { code: token } };
        this.handleAppleAuthCallbackResponse(objProviderResponse, client_id);
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.iagree !== this.props.iagree) {
      this.setState({ iagree: this.props.iagree });
    }

  }

  componentWillUnmount() {
    delete window.handleSignInFailure;
    delete window.receiveGoogleToken;
    delete window.receiveAppleToken;
  }

  handleAppleAuthCallbackResponse = async (providerResponse, providerClient_id) => {
    const {iagree} = this.props;
    this.closeModal();
    // Handle the response from Apple Sign In
    if (!providerClient_id) {
      providerClient_id = "km.cliente.signin";
    }
    const userProviderAuth = {
      //    google_id_token: providerResponse.credential,
      apple_code: providerResponse.authorization.code,
      client_id: providerClient_id,
      terms_accepted: iagree,
    };
    this.handleButtonClickAndLoading();
    const response = await AuthenticationService.authenticateProviderUser(userProviderAuth, this.props.navigate);
    if (response && response === 409) {
      this.props.iAgreeNotSet();
    }
  };

  handleGoogleAuthCallbackResponse = async (providerResponse) => {
    const {iagree} = this.props;
    const userProviderAuth = {
      google_id_token: providerResponse.credential,
      terms_accepted: iagree,
      //    apple_code: null,
    };
    this.handleButtonClickAndLoading();
    const response = await AuthenticationService.authenticateProviderUser(userProviderAuth, this.props.navigate);
    if (response && response === 409) {
      this.props.iAgreeNotSet();
    }
  };

  handleAppleAuthWebview = () => {
    try {
      this.handleButtonClickAndLoading();
      window.webkit.messageHandlers.appleSignIn.postMessage({});
    } catch (error) {
      console.error(error);
    }
  };

  handleGoogleSignInFailure = (error) => {
    // Handle sign-in failure
    console.error("handleGoogleSignInFailure", error);
  };

  createFakeGoogleWrapper = () => {
    const googleLoginWrapper = document.createElement("div");
    // Or you can simple hide it in CSS rule for custom-google-button
    googleLoginWrapper.style.display = "none";
    googleLoginWrapper.classList.add("custom-google-button");
    // Add the wrapper to body
    document.body.appendChild(googleLoginWrapper);

    let retryCount = 0;
    const maxRetries = 50; // 50 * 100ms = 5 seconds

    const renderButton = () => {
      if (window.google?.accounts?.id) {
        if (!this.googleInitialized) {
          window.google.accounts.id.initialize({
            client_id: "53380306481-u99na89i7nj3kor7mkkjmrrj72lj4scm.apps.googleusercontent.com",
            callback: this.handleGoogleAuthCallbackResponse,
          });
          this.googleInitialized = true;
        }
        window.google.accounts.id.renderButton(googleLoginWrapper, {
          theme: "outline",
          size: "medium",
          text: "continue_with",
          type: "standard",
          logo_alignment: "left",
          shape: "rectangular",
          locale: "pt-PT",
          width: "200",
        });
        const googleLoginWrapperButton = googleLoginWrapper?.querySelector("div[role=button]");
        return {
          click: () => {
            googleLoginWrapperButton?.click();
          },
        };
      } else if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(renderButton, 100);
        return { click: () => {} };
      } else {
        console.error("Google script failed to load or initialize after multiple attempts.");
        return { click: () => {} };
      }
    };
    return renderButton();
  };

  handleGoogleAuthWebview = () => {
    try {
      if (HelperWebView.isAndroidWebview()) {
        this.handleButtonClickAndLoading();
        window.Android.googleSignIn();
      }
      if (HelperWebView.isIOSWebview()) {
        this.handleButtonClickAndLoading();
        window.webkit.messageHandlers.googleSignIn.postMessage({});
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleGoogleLogin = () => {
    // Use wrapper click to prevent Illegal invocation exception
    this.handleButtonClickAndLoading();
    this.createFakeGoogleWrapper().click();
  };

  signUpProviderWarningWrapper = (shouldSignUpOnClose = true, showClose= false, appleSignInCallback=undefined) => {
    if (this.state.signUpWarningSent) {
      if (shouldSignUpOnClose ) {
        appleSignInCallback? appleSignInCallback() : this.handleStartProviderLogin();
      return;
      }
    }
    this.signUpProviderWarning(shouldSignUpOnClose, showClose, appleSignInCallback);
    this.setState({
      signUpWarningSent: true,
    })
  }

  signUpProviderWarning = (shouldSignUpOnClose = true, showClose= false, appleSignInCallback) => {
    //const { provider } = this.props;
    this.setState({
      modalInfoTitle: "Utilize o e-mail que forneceu ao seu prestador de serviços.", 
      modalInfoMessage: "Se tiver serviços contratados connosco,",
      modalInfoSubMessage: "utilize o mesmo **e-mail**, para aceder a todas as suas intervenções.",
      modalInfoConfirmText: "De acordo. Quero continuar.",
      modalInfoOnConfirm: shouldSignUpOnClose? (appleSignInCallback? appleSignInCallback : this.handleStartProviderLogin) : '',
      modalShowClose: showClose,
      modalInfoIsOpen: true,
    });
  }

  handleStartProviderLogin = () => {
    this.closeModal();
    const { provider } = this.props;
    if (provider === "google") {
      if (HelperWebView.isAndroidWebview() || HelperWebView.isIOSWebview()) {this.handleGoogleAuthWebview();}
      else {this.handleGoogleLogin();}
    }
    if (provider === "apple") {
      if (HelperWebView.isIOSWebview()) { this.handleAppleAuthWebview(); }
      else {this.handleAppleAuthCallbackResponse();}
    }
  }

  handleButtonClickAndLoading = (action) => {
    this.setState({ loading: true }, () => {
      if (action) {
        action();
      }
      setTimeout(() => {
        this.setState({ loading: false });
      }, 2000);
    });
  };

  renderModalInformation() {
    if (!this.state.modalInfoIsOpen) {
      return <React.Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={this.state.modalInfoIsOpen}
        title={this.state.modalInfoTitle}
        message={this.state.modalInfoMessage}
        subMessage={this.state.modalInfoSubMessage}
        confirmText={this.state.modalInfoConfirmText}
        onClose={this.closeModal}
        onConfirm={this.state.modalInfoOnConfirm || this.closeModal}
        showClose={this.state.modalShowClose}
      />
    );
  };

  closeModal = () => {
    this.setState({
      modalInfoTitle: "",
      modalInfoMessage: "",
      modalInfoSubMessage: "",
      modalInfoConfirmText: "",
      modalInfoOnConfirm: undefined,
      modalShowClose: true,
      modalInfoIsOpen: false,
    });
  };

  render() {
    const { provider } = this.props;
    let handleClick, buttonIcon, buttonText;
    const buttonStyle = {
      opacity: (this.state.iagree || this.state.login) ? 1 : 0.6,
      cursor: (this.state.iagree || this.state.login) ? 'pointer' : 'not-allowed'
    };

    if (provider === "google") {
      buttonIcon = IconGoogle
      buttonText = "Entrar com Google";
      handleClick = () => this.handleButtonClickAndLoading(() => this.signUpProviderWarningWrapper(true, true));

    }
    if (provider === "apple") {
      buttonIcon = IconApple;
      buttonText = "Entrar com Apple";
      handleClick = () => this.handleButtonClickAndLoading(() => this.signUpProviderWarningWrapper(true, true));

      if (HelperWebView.isAndroidWebview()) return null; // Don't show Apple button on Android App
      if (!HelperWebView.isAndroidWebview() && !HelperWebView.isIOSWebview()) {
        return (
          <React.Fragment>
            <AppleSignIn
              authOptions={{
                clientId: "km.cliente.signin",
                redirectURI: HelperConfig.welcomePageLink(), //ends with /
                responseType: "code",
                scope: "name email", //phone number?
                usePopup: true,
              }}
              onSuccess={this.handleAppleAuthCallbackResponse}
              onError={this.closeModal}
              render={(props) => (
                <button
                  {...props}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the default action
                    this.handleButtonClickAndLoading(() => this.signUpProviderWarningWrapper(true, true, props.onClick)); // Call your method first and then callback onClick
                  }}
                  className="cta-button-sign-in-provider d-medium w-100 mt-4 d-flex align-items-center justify-content-center"
                  disabled={!this.state.iagree && !this.state.login}
                  style={buttonStyle}
                >
                  <div className="d-inline-flex align-items-center justify-content-center position-relative">
                    <img src={buttonIcon} alt={`${provider}-icon`} />
                    <div className="ms-2">{buttonText}</div>
                    {this.state.loading && (
                      <div className="spinner-overlay">
                        <div className="spinner small"></div>
                      </div>
                    )}
                  </div>
                </button>
              )}
            />
            {this.renderModalInformation()}
          </React.Fragment>
        );
      }
    }

    return (
      <React.Fragment>
        <button
          className="cta-button-sign-in-provider d-medium w-100 mt-4 d-flex align-items-center justify-content-center"
          onClick={handleClick}
          disabled={!this.state.iagree && !this.state.login}
          style={buttonStyle}
        >
          <div className="d-inline-flex align-items-center justify-content-center position-relative">
            <img src={buttonIcon} alt={`${provider}-icon`} />
            <div className="ms-2">{buttonText}</div>
            {this.state.loading && (
              <div className="spinner-overlay">
                <div className="spinner small"></div>
              </div>
            )}
          </div>
        </button>
        {this.renderModalInformation()}
      </React.Fragment>


    );
  }
}

export default loginProvider;
